import { render, staticRenderFns } from "./noticeshow.vue?vue&type=template&id=3cab234b&scoped=true&"
import script from "./noticeshow.vue?vue&type=script&lang=js&"
export * from "./noticeshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab234b",
  null
  
)

component.options.__file = "noticeshow.vue"
export default component.exports